(function () {
  let zoomActive = false;
  let currentZoomedImage = null;
  let observer = null;
  let lastTap = 0;
  let touchStartDistance = 0;
  let pinchStartScale = 1;
  let startPan = { x: 0, y: 0 };
  let currentPan = { x: 0, y: 0 };
  let panStart = { x: 0, y: 0 };
  let isPanning = false;

  function startZoom() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initZoom);
    } else {
      initZoom();
    }
  }

  function initZoom() {
    injectZoomStyles();

    document.body.addEventListener("click", handleClick, true);
    document.body.addEventListener("touchstart", handleTouchStart, { passive: false });
    document.body.addEventListener("touchmove", handleTouchMove, { passive: false });
    document.body.addEventListener("touchend", handleTouchEnd, { passive: true });
    document.body.addEventListener("touchcancel", handleTouchEnd, { passive: true });
    document.body.addEventListener("mousemove", handleMouseMove, { passive: true });

    if (observer) observer.disconnect();
    observer = new MutationObserver(debounce(applyZoomToImages, 200));
    observer.observe(document.body, { childList: true, subtree: true });

    applyZoomToImages();
    setTimeout(integrateSwiperZoom, 500);
  }

  function applyZoomToImages() {
    document.querySelectorAll("img").forEach((img) => {
      if (isProductImage(img) && !img.classList.contains("zoomable-image")) {
        img.classList.add("zoomable-image");
      }
    });
  }

  function isProductImage(img) {
    if (img.closest(".card__media, .card-wrapper")) return false;
    return !!img.closest(".product__images");
  }

  function handleClick(event) {
    if (event.pointerType === "touch") return;
    const img = event.target.closest(".zoomable-image");
    if (!img) {
      if (zoomActive) deactivateZoom();
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (!zoomActive) {
      activateZoom(img, event);
    } else {
      deactivateZoom();
    }
  }

  function handleTouchStart(e) {
    const img = e.target.closest(".zoomable-image");
    if (!img) return;

    if (e.touches.length === 2) {
      e.preventDefault();
      touchStartDistance = getPinchDistance(e.touches);

      if (!currentZoomedImage) {
        const mid = getPinchCenter(e.touches);
        activateZoom(img, mid, 1);
        pinchStartScale = 1;
        if (currentZoomedImage) currentZoomedImage.style.transition = "none";
      } else {
        const transform = window.getComputedStyle(currentZoomedImage).transform;
        pinchStartScale = transform === "none" ? 1 : new DOMMatrix(transform).m11;
        currentZoomedImage.style.transition = "none";
      }
      return;
    }

    if (e.touches.length === 1) {
      const now = Date.now();
      if (now - lastTap < 300) {
        e.preventDefault();
        e.stopPropagation();
        if (!zoomActive) {
          activateZoom(img, e.touches[0]);
        } else {
          deactivateZoom();
        }
        return;
      }

      lastTap = now;

      if (zoomActive && img === currentZoomedImage) {
        isPanning = true;
        startPan.x = e.touches[0].clientX;
        startPan.y = e.touches[0].clientY;
        panStart.x = currentPan.x;
        panStart.y = currentPan.y;
        currentZoomedImage.style.transition = "none";
      }
    }
  }

  function handleTouchMove(e) {
    if (!currentZoomedImage) return;

    if (e.touches.length === 2) {
      e.preventDefault();
      const currentDistance = getPinchDistance(e.touches);
      const scaleRatio = currentDistance / touchStartDistance;
      let newScale = pinchStartScale * scaleRatio;
      newScale = Math.max(1, Math.min(newScale, 4));

      const mid = getPinchCenter(e.touches);
      const rect = currentZoomedImage.getBoundingClientRect();
      const x = ((mid.clientX - rect.left) / rect.width) * 100;
      const y = ((mid.clientY - rect.top) / rect.height) * 100;
      currentZoomedImage.style.transformOrigin = `${x}% ${y}%`;
      currentZoomedImage.style.transform = `scale(${newScale}) translate(${currentPan.x}px, ${currentPan.y}px)`;
      return;
    }

    if (isPanning && e.touches.length === 1) {
      const touch = e.touches[0];
      const currentScale = getCurrentScale();

      if (currentScale <= 1.05) {
        isPanning = false;
        return;
      }

      const deltaX = touch.clientX - startPan.x;
      const deltaY = touch.clientY - startPan.y;

      const logicalDeltaX = deltaX / currentScale;
      const logicalDeltaY = deltaY / currentScale;
      let newPanX = panStart.x + logicalDeltaX;
      let newPanY = panStart.y + logicalDeltaY;

      const rect = currentZoomedImage.getBoundingClientRect();
      const baseWidth = rect.width / currentScale;
      const baseHeight = rect.height / currentScale;
      const originValues = currentZoomedImage.style.transformOrigin.split(" ");
      const originX = parseFloat(originValues[0] || 50) / 100;
      const originY = parseFloat(originValues[1] || 50) / 100;

      const maxPanX = (1 - originX) * baseWidth * (1 - 1 / currentScale);
      const minPanX = -originX * baseWidth * (1 - 1 / currentScale);
      const maxPanY = (1 - originY) * baseHeight * (1 - 1 / currentScale);
      const minPanY = -originY * baseHeight * (1 - 1 / currentScale);

      const isMostlyVertical = Math.abs(deltaY) > Math.abs(deltaX) + 5;
      const isAtTopEdge = newPanY < minPanY;
      const isAtBottomEdge = newPanY > maxPanY;

      if (isMostlyVertical && (isAtTopEdge || isAtBottomEdge)) {
        isPanning = false;
        return;
      }

      e.preventDefault();

      currentPan.x = Math.max(minPanX, Math.min(newPanX, maxPanX));
      currentPan.y = Math.max(minPanY, Math.min(newPanY, maxPanY));

      currentZoomedImage.style.transform = `scale(${currentScale}) translate(${currentPan.x}px, ${currentPan.y}px)`;
    }
  }

  function handleTouchEnd(e) {
    if (e.touches.length === 0) {
      isPanning = false;
      touchStartDistance = 0;
      pinchStartScale = parseFloat(getCurrentScale()) || 1;

      if (pinchStartScale <= 1.05) deactivateZoom();
    }
  }

  function handleMouseMove(e) {
    if (!zoomActive || !currentZoomedImage || e.pointerType === "touch") return;
    const rect = currentZoomedImage.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    currentZoomedImage.style.transformOrigin = `${x}% ${y}%`;
  }

  function getPinchDistance(touches) {
    const dx = touches[0].clientX - touches[1].clientX;
    const dy = touches[0].clientY - touches[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function getPinchCenter(touches) {
    return {
      clientX: (touches[0].clientX + touches[1].clientX) / 2,
      clientY: (touches[0].clientY + touches[1].clientY) / 2,
    };
  }

  function getCurrentScale() {
    if (!currentZoomedImage) return 1;
    const transform = window.getComputedStyle(currentZoomedImage).transform;
    return transform === "none" ? 1 : new DOMMatrix(transform).m11;
  }

  function activateZoom(img, event, scale = 2.8) {
    if (zoomActive) return;
    const rect = img.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width) * 100;
    const y = ((event.clientY - rect.top) / rect.height) * 100;

    img.style.transformOrigin = `${x}% ${y}%`;
    img.classList.add("image__zoom");
    img.style.transform = `scale(${scale})`;

    zoomActive = true;
    currentZoomedImage = img;
    pinchStartScale = scale;
    currentPan = { x: 0, y: 0 };
    panStart = { x: 0, y: 0 };

    if (typeof swiper !== "undefined" && swiper) swiper.allowTouchMove = false;
  }

  function deactivateZoom() {
    if (!zoomActive) return;
    if (currentZoomedImage) {
      currentZoomedImage.classList.remove("image__zoom");
      currentZoomedImage.style.transform = "";
      currentZoomedImage.style.transition = "";
    }

    zoomActive = false;
    isPanning = false;
    currentZoomedImage = null;
    currentPan = { x: 0, y: 0 };
    panStart = { x: 0, y: 0 };

    if (typeof swiper !== "undefined" && swiper) swiper.allowTouchMove = true;
  }

  function integrateSwiperZoom() {
    if (typeof swiper === "undefined" || !swiper) return;
    swiper.on("slideChange", deactivateZoom);
    swiper.on("touchStart", () => zoomActive && deactivateZoom());
  }

  function injectZoomStyles() {
    if (document.getElementById("custom-zoom-style")) return;

    const style = document.createElement("style");
    style.id = "custom-zoom-style";
    style.textContent = `
      .zoomable-image {
        cursor: zoom-in;
        transition: transform 0.25s ease;
        user-select: none;
        -webkit-user-drag: none;
        -webkit-user-select: none;
      }

      .zoomable-image.image__zoom {
        cursor: zoom-out;
        position: relative;
        z-index: 999;
        will-change: transform;
        touch-action: none;
      }
    `;
    document.head.appendChild(style);
  }

  function debounce(fn, delay) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn(...args), delay);
    };
  }

  startZoom();
})();